import { createSlice } from '@reduxjs/toolkit'
const defaultDescription =
  'Need an exceptional speaker for your event? UTA Speakers represents the world’s greatest Speakers. Whether you are a Corporation, University, Trade Show, Conference, Town Hall, or Convention, find the best Speaker to create an unforgettable event.'

const initialState = {
  seo: {
    pageTitle: "An Exclusive Lineup - The World's Most Requested Experts | UTA Speakers",
    pageDescription: defaultDescription,
    ogImage: null,
  },
}

const speakersDefaultSeoState = {
  pageTitle: 'All Speakers | UTA Speakers',
  pageDescription:
    'Browse all UTA Speakers, from business and politics, technology and entertainment, literature, sports, and more.',
  ogImage: null,
}

const contactSeoState = {
  pageTitle: 'Contact | UTA Speakers',
  pageDescription: defaultDescription,
  ogImage: null,
}

const bookNowSeoState = {
  pageTitle: 'Book Now | UTA Speakers',
  pageDescription: defaultDescription,
  ogImage: null,
}

const generateSpeakersTags = (data) => {
  return {
    pageTitle: `${data?.pageTitle ? `${data?.pageTitle} |` : ''} Speaker ${
      data?.isType
    } | UTA Speakers`,
    pageDescription: data.pageDescription ? data?.pageDescription : '',
    ogImage: data?.ogImage || null,
  }
}

const generateSpeakerProfileTags = (data) => {
  return {
    pageTitle: data?.pageTitle,
    pageDescription: data?.pageDescription,
    ogImage: data?.ogImage,
  }
}

export const headSlice = createSlice({
  name: 'head',
  initialState,
  speakersDefaultSeoState,
  contactSeoState,
  bookNowSeoState,
  reducers: {
    setDefaultPageSeo: (state) => {
      state.seo = initialState.seo
    },
    setSpeakersDefaultSeo: (state) => {
      state.seo = speakersDefaultSeoState
    },
    setPageSeo: (state, action) => {
      state.seo = action.payload
    },
    setSpeakersSeo: (state, action) => {
      state.seo = generateSpeakersTags(action.payload)
    },
    setProfileSeo: (state, action) => {
      state.seo = generateSpeakerProfileTags(action.payload)
    },
    setContactSeo: (state) => {
      state.seo = contactSeoState
    },
    setBookNowSeo: (state) => {
      state.seo = bookNowSeoState
    },
  },
})

// Selectors
export const getSeoDetails = (state) => state.head.seo

// Action creators are generated for each case reducer function
export const {
  setDefaultPageSeo,
  setSpeakersDefaultSeo,
  setPageSeo,
  setProfileSeo,
  setSpeakersSeo,
  setContactSeo,
  setBookNowSeo,
} = headSlice.actions

export default headSlice.reducer
